/** Resolve a path to a file in `public/` against the Vite base URL.
 *
 *  In production the app is served at "/" so this is a no-op, but on the test
 *  stand it lives under a subpath (e.g. "/tg-bot/"). Hard-coding "/logo.jpg"
 *  then 404s because the browser asks the domain root. Prefixing BASE_URL keeps
 *  the same source working in both layouts. */
export function asset(path: string): string {
  const base = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');
  return base + (path.startsWith('/') ? path : `/${path}`);
}
